module.exports = __webpack_public_path__ + "static/media/antiClippy.0e8a5a15.png";